<div class="container page new-index" [style.padding]="govCompanyId ? '32px !important' : null">
    @if (govCompanyId) { <i class="im-icon im-icon-x-light" (click)="dismiss.emit()"></i>}
    <div *ngIf="!ready" class="mt-l mb-xxl">
        <app-spinner></app-spinner>
    </div>

    <ng-container *ngIf="ready">
        <div class="d-flex justify-content-between">
            <h1>{{'registrationhistorydetail_title' | translate}} <span class="light">{{'newindex_week' | translate}} {{weekNr ?? govWeek}} - {{year ?? govYear}}</span></h1>
        </div>

        <div class="panel">
            
            <ng-container *ngFor="let species of history; index as $i">
                <!-- title -->
                <h2 class="mb-xs">{{'newindex_subtitle_' + species.activity | translate}} - {{'newindex_subtitle_sector_' + species.code | translate}}</h2>
                <!-- table -->
                <table class="index index-form hide--lgx" [class.index-form--has-price]="species.code === 'beef' || species.activity === 'provider'">
                    <tr>
                        <th class="head--part">{{(species.code === 'beef' ? 'newindex_category' : 'newindex_part') | translate}}</th>
                        <th class="head--cat" *ngIf="true || !IndexService.noCategories(species.parts)">{{(species.code === 'beef' ? 'newindex_part' : 'newindex_category') | translate}}</th>
                        <th class="head--traded">{{'newindex_traded_in_belgium' | translate}}</th>
                        <th class="head--price" *ngIf="species.activity != 'buyer'">{{'newindex_price_week' | translate}} {{inputWeekInfo.weekNr ?? govWeek}}</th>
                        <th class="head--ticker">{{'newindex_difference_week' | translate}}</th>
                    </tr>
                    <tr *ngFor="let part of species.parts; index as $j" [class.tr--first]="IndexService.isFirstOfCategory(part.name, species.parts, $j)" [class.tr--last]="IndexService.isLastOfCategory(part.name, species.parts, $j)">
                        <!-- part -->
                        <td style="vertical-align: middle;" *ngIf="IndexService.isFirstOfCategory(part.name, species.parts, $j)" class="part" [attr.rowspan]="IndexService.isFirstOfCategory(part.name, species.parts, $j) ? IndexService.amountOfRows(part.name, species.parts) : 1">
                            <div class="d-flex align-items-center">
                                {{part.name}}
                            </div>
                        </td>
                        <!-- category -->
                        <td class="cat" *ngIf="true || !IndexService.noCategories(species.parts)">
                            {{part.cat}}
                        </td>
                        <!-- amount traded -->
                        <td>
                            <div class="d-flex align-items-center">
                                <div class="input-wrap">
                                    {{part.data.amount | formatNumber}}
                                </div>
                                <span *ngIf="part.unit" class="pieces">{{'newindex_unit_' + part.unit | translate}}</span>
                            </div>
                        </td>
                        <!-- price -->
                        <td *ngIf="species.activity != 'buyer'">
                            <div class="d-flex align-items-center">
                                <div class="input-wrap" [class.downlight]="part.data.price === undefined">
                                    {{part.data.price | toFixed: 2}}
                                </div>
                                <span *ngIf="part.data.price !== undefined" [class.downlight]="!part.data.amount" class="pieces">{{'unit_eur_' + part.unit | translate}}</span>
                            </div>
                        </td>
                        <!-- ticker index prev week -->
                        <td style="vertical-align: middle;">
                            <div class="d-flex align-items-center" [class.ticker-disabled]="!part.data.amount">
                                <!-- ticker -->
                                <div class="ticker d-flex align-items-center" [ngClass]="IndexService.getDirectionClass(part.data.fluctuation)">
                                    <i class="im-icon im-icon-{{IndexService.getDirectionIcon(part.data.fluctuation)}}"></i> {{part.data.fluctuation | cent}} <span class="eur-kg">{{'unit_eur_' + part.unit | translate}}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>

                <!-- mobile -->
                <div class="index mobile-index show--lgx" [class.mobile-index--has-price]="species.code === 'beef' || species.activity === 'provider'">
                    <ng-container *ngFor="let part of species.parts; index as $j">
                        <div class="mobile-index-section d-flex flex-column" *ngIf="!part.spacer">
                            <!-- name, cat -->
                            <div class="d-flex align-items-end justify-content-between">
                                <div class="clear-width">
                                    <span class="mobile-index-part">{{part.name}}</span>
                                    <span class="mobile-index-cat">{{part.cat}}</span>
                                </div>
                                <!-- tooltip xs -->
                                <div *ngIf="IndexService.fluctiationExceeds(part.data.fluctuation, part.maxFluctuation)" class="app-tooltip-wrap clear-width show--xs">
                                    <i class="im-icon im-icon-warning-filled"></i>
                                    <div class="app-tooltip">
                                        {{'newindex_tooltip_warning' | translate}}
                                    </div>
                                </div>
                                <!-- tooltip xs -->
                                <div *ngIf="IndexService.priceTooSmall(part.data.price, part.minPrice)" class="app-tooltip-wrap clear-width show--xs">
                                    <i class="im-icon im-icon-warning-filled"></i>
                                    <div class="app-tooltip">
                                        {{'price_too_small_tooltip_warning' | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex">
                                <!-- amount -->
                                <div class="d-flex flex-column">
                                    <span class="mobile-index-label">{{'newindexmobile_traded_in_belgium' | translate}}</span>
                                    <span class="mobile-index-value">
                                        <div class="d-flex align-items-center">
                                            <div class="input-wrap">
                                                {{part.data.amount | formatNumber}}
                                            </div>
                                            <span *ngIf="part.unit" class="pieces">{{'newindex_short_unit_' + part.unit | translate}}</span>
                                        </div>
                                    </span>
                                </div>
                                <!-- new price -->
                                <div class="d-flex flex-column price" *ngIf="species.activity == 'provider'">
                                    <span class="mobile-index-label">{{'newindexmobile_new_price' | translate}}</span>
                                    <span class="mobile-index-value">
                                        <div class="d-flex align-items-center">
                                            <div class="input-wrap" [class.downlight]="part.data.price === undefined">
                                                {{part.data.price | toFixed: 2}}
                                            </div>
                                            <span *ngIf="part.data.price !== undefined" class="pieces">{{'unit_short_eur_' + part.unit | translate}}</span>
                                        </div>
                                    </span>
                                </div>
                                <!-- ticker -->
                                <div class="d-flex flex-column">
                                    <span class="mobile-index-label">{{'newindexmobile_price_diff' | translate}}</span>
                                    <span class="mobile-index-value">
                                        <div class="d-flex align-items-center" [class.ticker-disabled]="!part.data.amount">
                                            <!-- ticker -->
                                            <div class="ticker d-flex align-items-center" [ngClass]="IndexService.getDirectionClass(part.data.fluctuation)">
                                                <i class="im-icon im-icon-{{IndexService.getDirectionIcon(part.data.fluctuation)}}"></i> {{part.data.fluctuation | cent}} <span class="eur-kg">{{'unit_short_eur_' + part.unit | translate}}</span>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                
            </ng-container>

            <div class="" style="margin-bottom: 20px;"></div>

            <div class="d-flex align-items-center justify-content-between">
                <div></div>
                <div class="edited-by hide--sm" *ngIf="editName && editTS">
                    {{'registrationhistorydetail_last_edited_by' | translate}} {{editName}} {{'misc_date_on' | translate}} {{editTS | formatTs: 'DD MMM YYYY'}} {{'misc_date_at' | translate}} {{editTS | formatTs: 'HH:mm'}}.
                </div>
            </div>

        </div>

        <div class="edited-by edited-by--mobile show--sm" *ngIf="editName && editTS">
            {{'registrationhistorydetail_last_edited_by' | translate}} {{editName}} {{'misc_date_on' | translate}} {{editTS | formatTs: 'DD MMM YYYY'}} {{'misc_date_at' | translate}} {{editTS | formatTs: 'HH:mm'}}.
        </div>

    </ng-container>

</div>